import { connect } from '@atlassian/jira-react-redux';
import { dismissFlagAction } from '@atlassian/jira-servicedesk-automation-common/src/state/flags/actions';
import { JsmPageInteractiveEvent } from '@atlassian/jira-servicedesk-common/src/utils/browser-metric/index.tsx';
import { summaryLoadRequest } from '../state/actions/retrieve';
import { getFlags } from '../state/selectors/base.tsx';
import { isLoading } from '../state/selectors/summary';
import type { State } from '../state/types';
import Layout from './layout';
import AutomationSummary from './view';

const mapStateToProps = (state: State) => ({
	LayoutComponent: Layout,
	JsmPageInteractiveEvent,
	isLoading: isLoading(state),
	flags: getFlags(state),
});

export default connect(mapStateToProps, {
	// @ts-expect-error - TS7006 - Parameter 'flagId' implicitly has an 'any' type.
	onFlagDismissed: (flagId) => dismissFlagAction(flagId),
	onMount: summaryLoadRequest,
})(AutomationSummary);
